<div class="dialog">
  @if (isLoading) {
    <div
      class="absolute w-full h-full top-0 flex justify-center items-center bg-white/40 backdrop-blur z-[1000]"
    >
      <mat-spinner></mat-spinner>
    </div>
  }
  <div class="headers">
    <div class="dialog-info-field">
      <div class="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 5V19M5 12H19"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="text-field">
        <p class="title">Create preset</p>
        <p class="description">Save your design</p>
      </div>
    </div>
    <button mat-icon-button class="close-btn" mat-dialog-close>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M17 7L7 17M7 7L17 17"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
  <div class="flex-none w-full h-[1px] bg-[#B9B9B9] my-[6px]"></div>
  <div class="data-field">
    <div class="thumbnail">
      <img [src]="data.thumbnail" alt="preset thumbnail" />
    </div>
    <form>
      <mat-form-field>
        <input matInput type="text" [formControl]="presetName" placeholder="Enter preset name" />
      </mat-form-field>
    </form>
  </div>
  <div class="btns-field">
    <button mat-flat-button class="sub-btn cancel" mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      class="normal-btn save"
      (click)="onClickSave()"
      [disabled]="!presetName.valid"
    >
      Save
    </button>
  </div>
</div>
